/* === Ronq CRO — Save pill injector for product pages === */
/* Moves the discount badge inline next to the price as "وفّر X%" */

(function() {
  function injectSavePill() {
    var hidden = document.querySelector('.product-detail__information .product__badges-inner.sale, .product-detail__information .product__badges-sale, .product-detail__information .sale_badge');
    var priceContainer = document.querySelector('.product-detail__information .card-product-price');
    if (!priceContainer) return;
    if (priceContainer.querySelector('.ronq-save-pill')) return;
    var rawText = '';
    if (hidden) {
      rawText = (hidden.innerText || hidden.textContent || '').trim();
    }
    if (!rawText) {
      var alt = document.querySelector('.product__badges-inner.sale, .product__badges-sale, .sale_badge');
      if (alt) rawText = (alt.innerText || alt.textContent || '').trim();
    }
    if (!rawText) return;
    var pct = rawText.replace(/[^0-9%-]/g, '');
    if (!pct) return;
    var pill = document.createElement('span');
    pill.className = 'ronq-save-pill';
    pill.textContent = 'وفّر ' + pct.replace('-', '');
    priceContainer.appendChild(pill);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectSavePill);
  } else {
    injectSavePill();
  }
  // Re-run after Shopify async hydration
  setTimeout(injectSavePill, 400);
  setTimeout(injectSavePill, 1200);
  setTimeout(injectSavePill, 2500);
  // Re-run on variant change (Shopify fires this on price update)
  document.addEventListener('variant:change', function() { setTimeout(injectSavePill, 200); });
})();

/* === Ronq CRO — Sticky bar price: bundle deal OR the product's own discount === */
/* Single-variant products show a static price in the sticky. Enrich it with the  */
/* struck-through original + savings — from the selected Kaching bundle when there */
/* is one, otherwise from the product's own compare-at sale price.                  */
(function() {
  var wired = false;

  function num(text) {
    return parseFloat((text || '').replace(/[^\d.]/g, '')) || 0;
  }

  function money(n) {
    return 'EGP ' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Selected Kaching bundle deal price + full price
  function bundlePrices() {
    var bar = document.querySelector('.kaching-bundles__bar--selected');
    var priceEl = bar && bar.querySelector('.kaching-bundles__bar-price');
    if (!priceEl) return null;
    return { price: num(priceEl.textContent), full: num((bar.querySelector('.kaching-bundles__bar-full-price') || {}).textContent) };
  }

  // Product's own price + compare-at (parsed from the main price block)
  function productPrices() {
    var card = document.querySelector('.product-detail__information .card-product-price')
      || document.querySelector('.product-detail__information .product-detail__price');
    if (!card) return null;
    var amts = (card.textContent || '').match(/EGP[\s]*[\d.,]+/gi);
    if (!amts || !amts.length) return null;
    var price = num(amts[0]);
    if (!price) return null;
    return { price: price, full: amts.length > 1 ? num(amts[1]) : 0 };
  }

  // Render into the sticky: price + (struck-through original + on-brand savings pill)
  function syncStickyPrice() {
    var p = bundlePrices() || productPrices();
    if (!p || !p.price) return;
    var saved = Math.max(0, p.full - p.price);
    var pct = p.full > 0 ? Math.round(saved / p.full * 100) : 0;
    var html = '<span class="ronq-sp__now">' + money(p.price) + '</span>';
    if (saved > 0 && p.full > p.price) {
      html += '<span class="ronq-sp__was"><s>' + money(p.full) + '</s></span>' +
        '<span class="ronq-sp__save">وفّرت ' + saved.toLocaleString('en-US') + ' · خصم ' + pct + '%</span>';
    }
    document.querySelectorAll('sticky-add-cart .sticky__price-single').forEach(function(el) {
      el.classList.add('ronq-sp');
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }

  // Kaching re-renders its widget, so bind at the document level (survives
  // subtree replacement) instead of observing a specific node that may detach.
  function onInteract(e) {
    var t = e.target;
    if (t && t.closest && t.closest('[class*="kaching-bundles"]')) {
      setTimeout(syncStickyPrice, 150);
      setTimeout(syncStickyPrice, 450);
    }
  }

  function init() {
    if (wired) return;
    wired = true;
    document.addEventListener('click', onInteract, true);
    document.addEventListener('change', onInteract, true);
    // Sync the default-selected bundle once Kaching has hydrated
    [300, 900, 1800, 3200].forEach(function(t) { setTimeout(syncStickyPrice, t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* === Ronq CRO — Main-area «اشتري الآن»: add to cart (bundle-aware) then checkout === */
/* The Shopify dynamic-checkout button does not render for the Egyptian/COD market, */
/* so this primary CTA reuses the real add-to-cart flow (which Kaching intercepts to */
/* add the selected bundle) and then forwards the shopper straight to checkout.       */
(function() {
  var PENDING_KEY = 'ronqBuyNowPending';
  var pending = false;

  function cartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(c) { return c.item_count; })
      .catch(function() { return null; });
  }

  function goCheckout() {
    if (!pending) return;
    pending = false; // keep .ronq-buying on: the drawer stays hidden until we leave
    try { sessionStorage.removeItem(PENDING_KEY); } catch (err) {}
    window.location.href = '/checkout';
  }

  function beginBuyNow() {
    pending = true;
    // Verified on live: the theme opens the minicart drawer ~1.4s after the add,
    // so the shopper sees the cart flash open before the checkout redirect lands.
    // This class keeps the drawer (and its overlay) hidden for the whole hop.
    document.documentElement.classList.add('ronq-buying');
    // Survives the edge case where a third-party redirect still wins the race:
    // the cart page then forwards to checkout instead of stranding the shopper.
    try { sessionStorage.setItem(PENDING_KEY, '1'); } catch (err) {}
  }

  function endBuyNow() {
    pending = false;
    document.documentElement.classList.remove('ronq-buying');
    try { sessionStorage.removeItem(PENDING_KEY); } catch (err) {}
  }

  // The theme's "go to cart page" post-add action navigates by clicking the
  // minicart anchor, and bundle apps do the same. While a buy-now is in flight
  // that navigation must be swallowed, otherwise the shopper sees /cart flash
  // before our checkout redirect lands.
  document.addEventListener('click', function(e) {
    if (!pending) return;
    var a = e.target.closest && e.target.closest('a[href*="/cart"]');
    if (!a || /\/cart\/(add|change|update)/.test(a.getAttribute('href') || '')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  // Redirect the instant the add-to-cart request resolves — no polling latency,
  // so nothing else gets a chance to navigate first.
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/add/.test(url)) {
        p.then(function(res) { if (pending && res && res.ok) goCheckout(); }).catch(function() {});
      }
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (/\/cart\/add/.test(url || '')) {
      this.addEventListener('load', function() {
        if (pending && this.status >= 200 && this.status < 300) goCheckout();
      });
    }
    return origOpen.apply(this, arguments);
  };

  // Fallback for adds we can't observe (form POST, sendBeacon, custom transport):
  // poll the cart until it grows past `before`, then forward to checkout.
  function redirectOnAdd(before, onTimeout) {
    var tries = 0;
    var iv = setInterval(function() {
      if (!pending) { clearInterval(iv); return; }
      tries++;
      cartCount().then(function(now) {
        if (now !== null && before !== null && now > before) {
          clearInterval(iv);
          goCheckout();
        } else if (tries >= 50) { // ~7.5s safety net
          clearInterval(iv);
          endBuyNow();
          if (onTimeout) onTimeout();
        }
      });
    }, 150);
  }

  // Safety net: a redirect that beat us landed the shopper on /cart — move them on.
  try {
    if (sessionStorage.getItem(PENDING_KEY) === '1') {
      sessionStorage.removeItem(PENDING_KEY);
      if (/^\/cart\/?$/.test(window.location.pathname)) {
        window.location.replace('/checkout');
        return;
      }
    }
  } catch (err) {}

  // Main-area «اشتري الآن»: type=button, so trigger the real add-to-cart then checkout.
  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('.ronq-buy-now-main');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var scope = btn.closest('.product-form') || btn.closest('form') || document;
    var atc = scope.querySelector('.product_submit_button');
    if (!atc) { window.location.href = '/cart'; return; }
    btn.disabled = true;
    btn.textContent = 'جارٍ التحويل…';
    beginBuyNow();
    cartCount().then(function(before) {
      atc.click(); // real add-to-cart — Kaching adds the selected bundle here
      redirectOnAdd(before, function() { window.location.href = '/cart'; });
    });
  }, true);

  // Sticky «اشتري الآن»: this IS the add-to-cart submit button. Intercept the first
  // click to snapshot the cart, then re-fire it so the theme performs the add, and
  // forward to checkout — keeping it consistent with the main-area primary CTA.
  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('sticky-add-cart .product_submit_button');
    if (!btn || btn.disabled) return;
    if (btn.getAttribute('data-ronq-pass') === '1') { // re-fired click → let the theme add
      btn.removeAttribute('data-ronq-pass');
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    beginBuyNow();
    // Kaching renders its bundle widget inside the MAIN product form and hooks that
    // form's submit only — the sticky bar has a form of its own, so adding through it
    // silently drops the selected bundle (verified on live: «دلع» 998 EGP / 4 items
    // arrived at checkout as the bare 799 EGP product). Whenever the bundle widget is
    // on the page, delegate the add to the main add-to-cart so both CTAs behave alike.
    var mainAtc = document.querySelector('.product-detail__information .product_submit_button');
    var hasBundles = !!document.querySelector('.kaching-bundles__bar');
    cartCount().then(function(before) {
      if (hasBundles && mainAtc && !mainAtc.disabled) {
        mainAtc.click();
      } else {
        btn.setAttribute('data-ronq-pass', '1');
        btn.click(); // real add-to-cart runs on this pass
      }
      redirectOnAdd(before);
    });
  }, true);
})();
